import { RawMaterialMasterThemeModeConfig } from './types';

const light: RawMaterialMasterThemeModeConfig = {
  rawMaterialMaster: {},
};

export default light;
